import React from 'react'

function QueryTour({ setStepsEnabled, setHomeScreenWalkThroughPopup }) {
  return (
    <div className="ContainerSubmitedSucess2 ">
      <div className="SubContainerSubmitedSucess innerContainerFlex">
        <div className="imageContainer">
          <img src="/gif/queries_guide.gif" alt="" />
        </div>
        <div className="rightContainer">
          <div className="studentLogos leftMargin">
            <div></div>
            <div>
              <img
                src="/StudentImg/BreathSchoolLogo.png"
                alt="icon"
                width={"30px"}
              ></img>
            </div>
          </div>
          <div className=" overallMarginHead" style={{ position: "relative" }}>
            <h4 className="textColor1"> Welcome to Query Section</h4>
            <img style={{ width: "35px", height: "35px", position: "absolute", left: "87%", top: "195px", cursor: "pointer", zIndex: "999" }} src="./images/down_arrow.png" alt="arrowimag" onClick={() => {
              document.getElementById("last-paragraph").scrollIntoView({ behavior: "smooth" })
            }} />
          </div>

          <div className=" overallMargin">
            <p className="textColor2">
              1. Access All the Curriculum Queries Anytime Anywhere. Important for Revision and Exam Preparation.
            </p>
            <hr></hr>
            <p className="textColor2" >
              2. Instant Doubt Resolution from Peer and Teachers.
            </p>
            <hr></hr>
            <p className="textColor2" >
              3. Help your Peers with their Queries and be Recognized.
            </p>
            <hr></hr>
            <p className="textColor2" >
              4. Access to Diverse Perspectives and Promotes Open Discussion of Ideas. Builds Problem-Solving Skills.
            </p>
            <hr></hr>
            <p className="textColor2" >
              5. Strengthens Peer Relationships and Creates a Supportive Learning Community.
            </p>
            <hr></hr>
            <p className="textColor2" id='last-paragraph'>
              6. Develops Confidence in Asking Questions and Communication Skill.
            </p>
            <hr></hr>
          </div>

          <div className="buttonsContainer">
            <button
              className="rightBtn"
              onClick={() => {
                setHomeScreenWalkThroughPopup(false);
                setStepsEnabled(true);
              }}
            >
              Take me to the product tour
            </button>
            <button
              className="leftBtn"
              onClick={() => setHomeScreenWalkThroughPopup(false)}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default QueryTour
